import { Box } from '@mui/material';
import { GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import React from 'react';

import { DateNavigator } from '@commons/DatePickers/DateNavigator';

import { getTheme } from '@commons/utils/theme';

export const ProductionPlanningDatagridToolbar = ({
  handleDateChange,
  selectedDate,
  maxFutureDate,
  isDisabled,
}) => {
  const theme = getTheme();

  return (
    <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
      {/* Left side - Filters */}
      <Box sx={{ display: 'flex', gap: 1 }}>
        <GridToolbarFilterButton disabled={isDisabled} />
      </Box>

      {/* Spacer */}
      <Box sx={{ flex: 1 }} />

      <DateNavigator
        handleDateChange={handleDateChange}
        isDisabled={isDisabled}
        maxFutureDate={maxFutureDate}
        // No max past date
        maxPastDate={null}
        selectedDate={selectedDate}
      />

      {/* Search */}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          paddingLeft: '4px',
          backgroundColor: isDisabled && theme.colors.greys.light,
        }}
      >
        <GridToolbarQuickFilter disabled={isDisabled} />
      </Box>
    </Box>
  );
};
